import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { useRemoveBranches } from '../../../../state/Branches/actions/useRemoveBranches';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useRemoveBranchControlFromWorkflow = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const { dispatch: editorDispatch } = useCampaignEditorContext();
  const removeBranches = useRemoveBranches();

  return useCallback(() => {
    const { nodes, edges } = Canvas.createFromState(state)
      .removeBranchControlNode()
      .convertToState();

    editorDispatch({
      type: 'RESET_TO_TRIGGER',
    });

    removeBranches();

    dispatch({
      type: 'UPDATE',
      payload: { nodes, edges },
    });
  }, [dispatch, editorDispatch, removeBranches, state]);
};
